import { buildApiRequest } from 'utils/api';
import { BASE_URL } from 'utils/urls';

const urlHelper = {
  getLeads: (params) => buildApiRequest('GET', `${BASE_URL}/odin/leads`, params),
  getLeadsFilters: (params) => buildApiRequest('GET', `${BASE_URL}/filters/leadListing`, params),
  getLeadConfig: () => buildApiRequest('GET', `${BASE_URL}/odin/leads/config`),
  getLeadInfo: (params) => buildApiRequest('GET', `${BASE_URL}/odin/leads/${params}`),
  updateLead: (params) => buildApiRequest('PUT', `${BASE_URL}/odin/leads/`, params),
  leadExotel: (params) => buildApiRequest('GET', `${BASE_URL}/odin/leads/call?pocNo=${params}`),
  updateHotLead: (params) => buildApiRequest('PUT', `${BASE_URL}/odin/leads/hotLead`, params),
};

export default urlHelper;
